<template>
  <div>
    <LvInfoBox class="my-1">
      <v-btn
        text
        x-large
        color="primary"
        to='/answer_setting/create'
        class="pa-0"
        height="fit-content"
      >點此建立建議常用選項組合公版</v-btn>
      <p class="mb-1">您可以點擊下列選項組合快捷鍵，快速建立選項！</p>
      <p class="mb-1">ESGoal系統建議常用選項組合：</p>
      <div
        v-if="isLoading.optionList"
        class="loading-section"
      >
        <v-progress-circular
          size="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <div v-else>
        <WsBtn
          v-for="(option, optionIndex) in optionList"
          :key="optionIndex"
          outlined
          color="primary"
          @click="$_onSelect(option)"
          class="mr-1"
        >
          {{option.locales[_selectingLocale].name}}
        </WsBtn>
      </div>
    </LvInfoBox>
    <LvInfoBox >
      <div
        v-if="isLoading.optionItemList"
        class="loading-section"
      >
        <v-progress-circular
          size="20"
          color="primary"
          indeterminate
        ></v-progress-circular>
      </div>
      <LvInfoOption v-else-if="optionItemList.length" :value="optionItemList"/>
      <p v-else class="mb-1">尚未選擇選項組合公版</p>
    </LvInfoBox>
  </div>
</template>

<script>
import M_optionItem from '@/models/optionItem';
import S_answerSetting from '@/services/api/v1/answerSetting';
import S_answerSettingItems from '@/services/api/v1/answerSettingItems';

export default {
  props: {
    value: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: {
        optionList: false,
        optionItemList: false,
        submit: false,
      },
      optionList: [],
      optionItemList: [],
      fields: M_optionItem.fields.optionItem.fields,
    }
  },
  computed: {
    _selectingLocale() {
      return this.$store.state.locale.selectingLocale;
    },
  },
  async mounted() {
    this.optionList = await this.$_getOptionList();
    if (this.value && this.value.id) {
      const tarOption = this.optionList.find(option => option.id === this.value.id);
      await this.$_onSelect(tarOption);
    }
  },
  methods: {
    async $_getOptionList() {
      this.isLoading.optionList = true;
      const res = await S_answerSetting.indexOption();
      this.isLoading.optionList = false;
      return res;
    },
    async $_onSelect(option) {
      this.optionItemList = await this.$_getOptionItemList(option.id);
      this.$emit('input', {
        ...option,
        optionItemList: this.optionItemList,
      })
    },
    async $_getOptionItemList(optionId) {
      this.isLoading.optionItemList = true;
      const res = await S_answerSettingItems.index(optionId);
      this.isLoading.optionItemList = false;
      return res;
    }
  },
}
</script>